import React, { useEffect } from 'react';

const LanguageSelector = () => {
  const languageMap = {
    'en': { name: 'English', flag: require("../assets/gb.svg").default },
    'hi': { name: 'हिन्दी', flag: require("../assets/in.svg").default },
    'fr': { name: 'Français', flag: require("../assets/countries/fr.svg").default },
    'de': { name: 'Deutsch', flag: require("../assets/countries/de.svg").default },
    'es': { name: 'Español', flag: require("../assets/us.svg").default },
    'zh-CN': { name: '中文', flag: require("../assets/countries/cn.svg").default },
    'ja': { name: '日本語', flag: require("../assets/countries/jp.svg").default },
    'ko': { name: '한국어', flag: require("../assets/countries/kr.svg").default },
    'nl': { name: 'Nederlands', flag: require("../assets/countries/nl.svg").default },
    'ar': { name: 'العربية', flag: require("../assets/ae.svg").default },
  };

  useEffect(() => {
    // Initialize Google Translate
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,hi,fr,de,es,zh-CN,ja,ko,nl,ar',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        'google_translate_element'
      );

      // Add flags to options after initialization
      setTimeout(() => {
        const selectElement = document.querySelector('.goog-te-combo');
        if (selectElement) {
          // Add custom styling with flags
          const options = selectElement.querySelectorAll('option');
          options.forEach((option) => {
            const langCode = option.value;
            if (languageMap[langCode]) {
              option.textContent = languageMap[langCode].name;
              option.setAttribute('data-flag', languageMap[langCode].flag);
            }
          });

          // Add flag display functionality
          selectElement.addEventListener('change', updateFlag);
          updateFlag(); // Initial update
        }
      }, 1000);
    };

    function updateFlag() {
      const selectElement = document.querySelector('.goog-te-combo');
      const selectedOption = selectElement?.options[selectElement.selectedIndex];
      const flagContainer = document.getElementById('current-language-flag');

      if (selectedOption && flagContainer) {
        const langCode = selectedOption.value;
        const langData = languageMap[langCode];
        if (langData) {
          flagContainer.innerHTML = `<img src="${langData.flag}" alt="${langData.name}" class="language-flag" />`;
        }
      }
    }

    // Load Google Translate script
    if (!document.getElementById('google-translate-script')) {
      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      document.body.appendChild(script);
    } else if (window.google && window.google.translate) {
      window.googleTranslateElementInit();
    }
  }, []);

  return (
    <div className="language-selector-wrapper">
      <div id="current-language-flag" className="current-flag"></div>
      <div id="google_translate_element"></div>
    </div>
  );
};

export default LanguageSelector;
